import { render } from "./Visiting_Guide.vue?vue&type=template&id=06057b8d"
import script from "./Visiting_Guide.vue?vue&type=script&lang=js"
export * from "./Visiting_Guide.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__